app.EmployerPrePostInstructions = (
    function () {
        var prePostInstructions = {
            // All pages - used for initializing
            Index: function () {
                // when one of the edit components on this page is loaded,
                // set the cols on all textareas so they're a little larger

                // event that's fired when an edit component has loaded
                $(document).on("component-bind-edit-mode-complete", function () {
                    $("textarea").each(function () {
                        this.rows = 10;
                    });
                });
            }
        };

        return prePostInstructions;
    }()
);